import cookie from 'js-cookie'
export default {
  get (key) {
    let response = {}
    let cache = decodeURIComponent(cookie.get(key))

    try {
      if (cache !== 'undefined') {
        response = JSON.parse(cache)
      }
    } catch (e) {
      response = cache
    }

    return response
  },
  set (key, value) {
    this.remove(key)

    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }
    cookie.set(key, encodeURIComponent(value), { expires: 30, domain: '.infoq.cn' })
  },

  remove (key) {
    cookie.remove(key, {domain: '.infoq.cn'})
  }
}
